import React, { Component } from 'react';
import { createCombineReducers } from 'mt-react-common/modules/complaints/addComplaintForm/combineRegistry';
import PropTypes from 'prop-types';
import ComplaintReportPopUpForTask from './ComplaintReportPopUpForTask';

class ComplaintReportPopUpForTaskRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `addComplaintForm-Task-${this.props.id}`
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <ComplaintReportPopUpForTask
          {...this.props}
          reducerName={this.state.reducerName}
        />
      </React.Fragment>
    );
  }
}

ComplaintReportPopUpForTaskRWrapper.propTypes = {
  id: PropTypes.string.isRequired
};

export default ComplaintReportPopUpForTaskRWrapper;



// WEBPACK FOOTER //
// ./src/components/Complaints/ComplaintReportPopUpForTask/index.js